import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import Vue from 'vue';

// Sentry
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

// Font awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Tailwind
import '@/assets/tailwind.css';
import '@/plugins/vue-tailwind';

import {
  WButton,
  WCheckboxGroup,
  WInput,
  WLoading,
  WModal,
  WRadioGroup,
  WTabs,
} from '@/components';
import breakpoints from '@/plugins/breakpoints';
import qrCode from '@/plugins/qrCode';
import Snackbar from '@/plugins/snackbar';

import App from './App.vue';
import api from './plugins/api';
import store from './store';
import router from './router';
import './plugins/filters';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

Vue.config.productionTip = false;

library.add(fas, far);

// Components
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('w-button', WButton);
Vue.component('w-checkbox-group', WCheckboxGroup);
Vue.component('w-input', WInput);
Vue.component('w-loading', WLoading);
Vue.component('w-modal', WModal);
Vue.component('w-radio-group', WRadioGroup);
Vue.component('w-tabs', WTabs);

// Plugins
Vue.use(api, { router, store });
Vue.use(breakpoints);
Vue.use(qrCode);
Vue.use(Snackbar);

// Sentry
Sentry.init({
  Vue,
  dsn: 'https://2ced40c6ad904e94b60cfdfe4598fce9@o78883.ingest.sentry.io/6069847',
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ['localhost', 'takeorder.tw', /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');
